import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "50",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      r: "7.107",
      fill: "#7ED321",
      opacity: ".2",
      transform: "matrix(-1 0 0 1 7.358 7.107)"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#7ED321",
      d: "m50 7.107-6.19 3.574V3.533zm-5.571.62H7.358V6.487h37.07z"
    }, null, -1),
    _createElementVNode("circle", {
      r: "4.119",
      fill: "#7ED321",
      stroke: "#7ED321",
      "stroke-width": "1.238",
      transform: "matrix(-1 0 0 1 7.358 7.107)"
    }, null, -1)
  ]))]))
}
export default { render: render }